import { useInfiniteGetMyAccountDocumentTemplates } from '@/api/queries/me/useGetMyAccountDocumentTemplates';
import { GetDocumentTemplatesInput } from '@/gql/graphql';
import { Card, Modal, ModalProps, SkeletonLoader } from '@payaca/ambrosia';
import InfiniteList from '@payaca/components/infiniteList/InfiniteList';

import UntitledIcon from '@payaca/untitled-icons';
import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';

export type TProps = Pick<ModalProps, 'isOpen' | 'onClose'> & {
  projectId: string;
  folderId?: string;
};

const ChooseDocumentTemplateModal: FC<TProps> = (props) => {
  const { isOpen, onClose, projectId, folderId } = props;

  const [documentTemplateInput, setDocumentTemplateInput] = useState<
    GetDocumentTemplatesInput | undefined
  >(undefined);

  const { documentTemplates, hasNextPage, fetchNextPage, isLoading } =
    useInfiniteGetMyAccountDocumentTemplates({
      input: documentTemplateInput,
    });

  return (
    <>
      <Modal title="Choose a Template" isOpen={isOpen} onClose={onClose}>
        <InfiniteList>
          <InfiniteList.Header>
            <InfiniteList.Search
              autoFocus
              placeholder="Search document templates..."
              onChangeTimeout={(value) => {
                setDocumentTemplateInput({
                  searchTerm: value,
                });
              }}
            />
          </InfiniteList.Header>

          <InfiniteList.List
            isLoading={isLoading}
            numOfSkeletonLoaders={1}
            canLoadMore={hasNextPage}
            onLoadMore={fetchNextPage}
            items={documentTemplates || []}
            emptyStateText="No document templates found"
            skeletonItem={
              <Card>
                <Card.Body>
                  <SkeletonLoader.Title className="w-40 mb-2" />
                  <SkeletonLoader.Text />
                </Card.Body>
              </Card>
            }
            item={(template) => {
              return (
                <Card
                  as={Link}
                  key={template.id}
                  className="text-[var(--tw-prose-root)] font-normal hover:cursor-pointer hover:bg-gray-100 hover:no-underline"
                  to={`/projects/${projectId}/documents/preview/${
                    template.id
                  }?folderId=${folderId || ''}`}
                >
                  <Card.Body>
                    <div className="flex items-center gap-2.5">
                      <UntitledIcon name="file-04" className="w-5 h-5" />
                      <h4>{template.name}</h4>
                    </div>
                    <p className="supporting-body text-gray-500 mt-2">
                      {template.description}
                    </p>
                  </Card.Body>
                </Card>
              );
            }}
          />
        </InfiniteList>
      </Modal>
    </>
  );
};

export default ChooseDocumentTemplateModal;
